import {
    Grid,
    TextField,
    FormHelperText,
    Select,
    MenuItem
  } from "@mui/material";
import { MdCloudUpload, MdDelete } from 'react-icons/md';
import { AiFillFileImage } from 'react-icons/ai';
import { useState } from "react";
import './images.css';
import {
  Typography,
  List,
  ListItem,
  ListItemText
} from '@mui/material';


const MoreDetails = (props) => {
    const { formik } = props;
    const  {values}  = formik;
    const [image, setImage] = useState(null)
    const [fileName, setFileName] = useState("No selected file")

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
        setFileName(file.name);
        setImage(URL.createObjectURL(file));
        formik.setFieldValue("ghCardImage", file);
        }
    };

    return(
        <div>
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <TextField
                    name="nextOfKin"
                    id="nextOfKin"
                    label="Next of Kin"
                    variant="outlined"
                    type="text"
                    fullWidth
                    size="small"
                    value={formik.values.nextOfKin}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                />
            </Grid>
            <Grid item xs={12}>
                <div className="form">
                    <input
                        name="ghCardImage"
                        id="ghCardImage"
                        type="file"
                        accept="image/*"
                        className="input-field"
                        onChange={handleFileChange}
                    />

                    {image ? (
                    <img src={image} width={150} height={150} alt={fileName} />
                    ) : (
                    <>
                        <MdCloudUpload color="#1475cf" size={60} />
                        <p>Browse Files to upload Ghana Card Photo</p>
                    </>
                    )}

                    <section className="uploaded-row">
                    <AiFillFileImage color="#1475cf" />
                    <span className="upload-content">
                        {fileName} --
                        <MdDelete
                        onClick={() => {
                            setFileName("No selected File");
                            setImage(null);
                            formik.setFieldValue("ghCardImage", null);
                        }}
                        />
                    </span>
                    </section>
            </div>
            </Grid>
            <Grid item xs={12}>
                <p>Marital Status</p>
                <Select
                    name="MaritalStatus"
                    id="MaritalStatus"
                    label="Marital Status"
                    variant="outlined"
                    size="small"
                    fullWidth
                    value={formik.values.MaritalStatus}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                >
                    <MenuItem value="married">Married</MenuItem>
                    <MenuItem value="single">Single</MenuItem>
                    <MenuItem value="divorced">Divorced</MenuItem>
                    <MenuItem value="widowed">Widowed</MenuItem>
                </Select>
            </Grid>
            <Grid item xs={12}>
             <p>Education Level</p>
                <Select
                    name="EducationLevel"
                    id="EducationLevel"
                    label="Education Level"
                    variant="outlined"
                    size="small"
                    fullWidth
                    value={formik.values.EducationLevel}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                >
                <MenuItem value="no_school">No School</MenuItem>
                <MenuItem value="kindergarten">Kindergarten</MenuItem>
                <MenuItem value="primary_school">Primary School</MenuItem>
                <MenuItem value="jhs_school">Junior High School</MenuItem>
                <MenuItem value="high_school">Senior High School</MenuItem>
                <MenuItem value="high_school">University</MenuItem>
                <MenuItem value="vocational">Vocational/Trade School</MenuItem>
                <MenuItem value="certificate">Certificate Program</MenuItem>
                <MenuItem value="bachelor_degree">Bachelor's Degree</MenuItem>
                <MenuItem value="master_degree">Master's Degree</MenuItem>
                <MenuItem value="doctoral_degree">Doctoral Degree</MenuItem>
                <MenuItem value="post_doctoral">Post-Doctoral</MenuItem>

                </Select>
            </Grid>
            <Grid item xs={12}>
                <TextField
                    name="Town"
                    id="Town"
                    label="Town/City"
                    variant="outlined"
                    type="text"
                    fullWidth
                    size="small"
                    value={formik.values.Town}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                />
            </Grid>
            <Grid item xs={12}>
                <p>Area Type</p>
                <Select
                    name="ruralOrUrban"
                    id="ruralOrUrban"
                    label="Area Status"
                    variant="outlined"
                    size="small"
                    fullWidth
                    value={formik.values.ruralOrUrban}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                >
                    <MenuItem value="rural_area">Rural Area</MenuItem>
                    <MenuItem value="urban_area">Urban Area</MenuItem>
                </Select>
            </Grid>
            {/* {formik.errors.submit && (
                <Grid item xs={12}>
                <FormHelperText error>
                    {formik.errors.submit}
                </FormHelperText>
                </Grid>
            )} */}
            <Grid item xs={12}>
            <>
                    <Typography variant="overline" >
                    Personal Information
                    </Typography>
                    <List>
                    <ListItem>
                        <ListItemText
                        primary="First Name"
                        secondary={values.firstname}
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemText
                        primary="Middle Name"
                        secondary={values.middlename}
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemText
                        primary="Last Name"
                        secondary={values.lastname}
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemText
                        primary="Date of Birth"
                        secondary={values.dob}
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemText
                        primary="Gender"
                        secondary={values.gender}
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemText
                        primary="Other Name"
                        secondary={values.otherName}
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemText
                        primary="Common Name"
                        secondary={values.commonname}
                        />
                    </ListItem>
                    </List>
                    <Typography variant="overline">
                    Address Information
                    </Typography>
                    <List>
                    <ListItem>
                        <ListItemText
                        primary="Phone Contact"
                        secondary={values.phone}
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemText
                        primary="other Phone"
                        secondary={values.otherPhone}
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemText
                        primary="Address"
                        secondary={values.address}
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemText
                        primary="other Address"
                        secondary={values.otherAddress}
                        />
                    </ListItem>
                    </List>
                    <Typography variant="overline">
                    More Information
                    </Typography>
                    <List>
                    <ListItem>
                        <ListItemText
                        primary="Next of Kin"
                        secondary={values.nextOfKin}
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemText
                        primary="Marital Status"
                        secondary={values.MaritalStatus}
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemText
                        primary="Education Level"
                        secondary={values.EducationLevel}
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemText
                        primary="Town/City"
                        secondary={values.Town}
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemText
                        primary="Address Type"
                        secondary={values.ruralOrUrban}
                        />
                    </ListItem>
                    </List>
                </>
            </Grid>
        </Grid>
    </div>
    )
}
export default MoreDetails;